
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9899P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d0dce9d9918bf1ac$export$2e2bcd8739ae039);

var $1MsVI = parcelRequire("1MsVI");

var $lldcY = parcelRequire("lldcY");
var $d0dce9d9918bf1ac$export$2e2bcd8739ae039 = (0, $lldcY.createReportPageBootstrap)('cumulative', (0, $1MsVI.default));

});
parcelRegister("1MsVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $491f7251dd183422$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $yuXsW = parcelRequire("yuXsW");

var $2Wgbz = parcelRequire("2Wgbz");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $94EW1 = parcelRequire("94EW1");

var $5YKhl = parcelRequire("5YKhl");


var $9IKEm = parcelRequire("9IKEm");

var $7OVAa = parcelRequire("7OVAa");

var $5b4Jf = parcelRequire("5b4Jf");
function $491f7251dd183422$export$76496011ae567893({ boardId: boardId }) {
    const children = false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b4Jf.default), {
        isDisabled: true,
        lowerOpacity: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7OVAa.default), {
        boardId: boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: (0, $2Wgbz.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: (0, $9IKEm.APP_ID),
        teamName: "helios-reports",
        packageName: "@atlassian/jira-software-cumulative-flow-diagram"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, children)));
}
const $491f7251dd183422$var$App = (props)=>{
    const { baseUrl: baseUrl, projectKey: projectKey, boardId: boardId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5YKhl.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        boardId: boardId,
        reportType: (0, $07d657390afa880f$export$1c3e2d262d98feed)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($491f7251dd183422$export$76496011ae567893, {
        boardId: boardId
    }));
};
var $491f7251dd183422$export$2e2bcd8739ae039 = $491f7251dd183422$var$App;

});
parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("2Wgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e169a67ca28ac2$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");

var $8Y3VE = parcelRequire("8Y3VE");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $5zSUY = parcelRequire("5zSUY");

var $eeJ3R = parcelRequire("eeJ3R");

var $aXA7t = parcelRequire("aXA7t");

var $277yk = parcelRequire("277yk");



const $a3e169a67ca28ac2$var$retryLink = new (0, $kcwGc.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $eeJ3R.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $a3e169a67ca28ac2$var$errorLink = (0, $aqG9W.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(extensions, [
                'errorType'
            ], null);
            return (0, $eeJ3R.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $eeJ3R.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
            'statusCode'
        ], null);
        (0, $eeJ3R.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $a3e169a67ca28ac2$var$fragmentMatcher = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($277yk))
});
const $a3e169a67ca28ac2$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $a3e169a67ca28ac2$var$fragmentMatcher
};
const $a3e169a67ca28ac2$var$cache = new (0, $2vRh6.InMemoryCache)($a3e169a67ca28ac2$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a3e169a67ca28ac2$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $a3e169a67ca28ac2$var$xsrfLink = ()=>(0, $8Y3VE.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $5zSUY.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $a3e169a67ca28ac2$var$clientCreator = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: 'SWAG',
        link: (0, $bvQX6.ApolloLink).from([
            $a3e169a67ca28ac2$var$retryLink,
            $a3e169a67ca28ac2$var$xsrfLink(),
            $a3e169a67ca28ac2$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($a3e169a67ca28ac2$var$cache),
            new (0, $35Kb7.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $a3e169a67ca28ac2$var$customFetch
            })
        ]),
        cache: $a3e169a67ca28ac2$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$a3e169a67ca28ac2$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $a3e169a67ca28ac2$var$clientCreator
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});

parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("8Y3VE", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $6876f98359b8915e$export$2f04de43fe27971a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $6876f98359b8915e$export$2f04de43fe27971a(setter) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        var request = (0, $fKE23.__rest)(operation, []);
        return new (0, $bvQX6.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $bvQX6.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $bvQX6.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $bvQX6.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $bvQX6.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $bvQX6.Observable).of({
                data: {}
            });
            return new (0, $bvQX6.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("eeJ3R", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $ff92a92e5b2be045$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $ff92a92e5b2be045$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $ff92a92e5b2be045$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $ff92a92e5b2be045$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $ff92a92e5b2be045$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $ff92a92e5b2be045$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $ff92a92e5b2be045$export$3e50530825dee9d1);

var $gUUjF = parcelRequire("gUUjF");
const $ff92a92e5b2be045$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $gUUjF.default).safeErrorWithoutCustomerData(type, m, params);
};
const $ff92a92e5b2be045$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $ff92a92e5b2be045$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$ff92a92e5b2be045$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $ff92a92e5b2be045$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $ff92a92e5b2be045$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $ff92a92e5b2be045$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $ff92a92e5b2be045$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $ff92a92e5b2be045$export$25d52be9f4671e9e = (error, queryName)=>{
    $ff92a92e5b2be045$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $ff92a92e5b2be045$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $ff92a92e5b2be045$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $gUUjF.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fYqUr = parcelRequire("fYqUr");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fYqUr.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("277yk", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("94EW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d0e968743ebc023$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $7d0e968743ebc023$var$Spinner = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7d0e968743ebc023$var$SpinnerContainer, {
        "data-test-id": testId,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
var $7d0e968743ebc023$export$2e2bcd8739ae039 = $7d0e968743ebc023$var$Spinner;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d0e968743ebc023$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1tke1mjv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5YKhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9578c7dbc76b3a6a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kIY50 = parcelRequire("kIY50");

var $8WuJm = parcelRequire("8WuJm");

var $fijOW = parcelRequire("fijOW");

var $7Uhfl = parcelRequire("7Uhfl");
function $9578c7dbc76b3a6a$export$2e2bcd8739ae039({ baseUrl: baseUrl, boardId: boardId, children: children, reportType: reportType, projectKey: projectKey }) {
    const reportsUrl = `${baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            boardType: 'Agility'
        }
    }, (0, $kIY50.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fijOW.default), {
        boardId: boardId,
        projectKey: projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Uhfl.default), {
        reportType: reportType,
        reportsUrl: reportsUrl,
        boardId: boardId
    }, children));
}

});
parcelRegister("fijOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bf4db62e7e9525$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts = (0, $7rh0R.lazy)(()=>(parcelRequire("b2w1X")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $68bf4db62e7e9525$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($68bf4db62e7e9525$var$LazyProjectKeyboardShortcuts, props)));
var $68bf4db62e7e9525$export$2e2bcd8739ae039 = $68bf4db62e7e9525$var$ProjectKeyboardShortcuts;

});
parcelRegister("b2w1X", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("28hU0")
]).then(()=>parcelRequire('8aQut'));

});


parcelRegister("7Uhfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $01c9d5272f200bc5$export$2e2bcd8739ae039);

var $fHwH9 = parcelRequire("fHwH9");

var $1PNaF = parcelRequire("1PNaF");

var $a1jkl = parcelRequire("a1jkl");
var $01c9d5272f200bc5$export$2e2bcd8739ae039 = (0, $fHwH9.default)({
    Header: $1PNaF.default
})((0, $a1jkl.default));

});
parcelRegister("fHwH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83371236161dde7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $e83371236161dde7$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $e83371236161dde7$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$e83371236161dde7$var$isEmpty(x.displayName)) return x.displayName;
    if (!$e83371236161dde7$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $e83371236161dde7$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $e83371236161dde7$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $e83371236161dde7$export$2e2bcd8739ae039 = $e83371236161dde7$export$19c55c6cefb3b57;

});

parcelRegister("1PNaF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1435ed448d0e9ab$export$2e2bcd8739ae039);

var $c76ap = parcelRequire("c76ap");

var $fHwH9 = parcelRequire("fHwH9");

var $eGoYe = parcelRequire("eGoYe");

var $gJRME = parcelRequire("gJRME");

var $6VbGL = parcelRequire("6VbGL");

var $78k8U = parcelRequire("78k8U");
var $c1435ed448d0e9ab$export$2e2bcd8739ae039 = (0, $fHwH9.default)({
    BreadcrumbRenderer: $c76ap.default,
    HowTo: $gJRME.default,
    Chevron: $eGoYe.default,
    HowToReadText: $6VbGL.default
})((0, $78k8U.default));

});
parcelRegister("eGoYe", function(module, exports) {

$parcel$export(module.exports, "default", () => $d36a23fa96896270$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");


var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");

var $3Gpwl = parcelRequire("3Gpwl");
const $d36a23fa96896270$var$ChevronIconComponent = ({ onClick: onClick, showHowTo: showHowTo, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d36a23fa96896270$var$ChevronIcon, {
        onClick: onClick
    }, showHowTo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: intl.formatMessage((0, $3Gpwl.default).hideHowToRead),
        size: "medium",
        primaryColor: `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
        label: intl.formatMessage((0, $3Gpwl.default).howToRead),
        size: "medium",
        primaryColor: `var(--ds-text-brand, ${(0, $73a5c9d720aa66e1$exports).B400})`
    }));
const $d36a23fa96896270$var$ChevronWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('reportPageHeader', {
    onClick: 'howToToggled'
})($d36a23fa96896270$var$ChevronIconComponent);
var $d36a23fa96896270$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($d36a23fa96896270$var$ChevronWithAnalytics);
const $d36a23fa96896270$var$ChevronIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _1skzyfq0",
            __cmplp.className
        ])
    });
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("3Gpwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a18a116ec213f13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a18a116ec213f13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    howToRead: {
        "id": "software-reports-report-page.header.chevron.how-to-read",
        "defaultMessage": "How to read this report"
    },
    hideHowToRead: {
        "id": "software-reports-report-page.header.chevron.hide-how-to-read",
        "defaultMessage": "Hide report help"
    }
});

});


parcelRegister("gJRME", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f725212b9b9021$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5OdZ3 = parcelRequire("5OdZ3");

var $gUUjF = parcelRequire("gUUjF");

var $8uD7Y = parcelRequire("8uD7Y");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");


var $g8w56 = parcelRequire("g8w56");
class $f8f725212b9b9021$export$d2e991ab6448c561 extends (0, $eUqFw.Component) {
    static getHowToDataForReportType(reportType) {
        switch(reportType){
            case 0, $07d657390afa880f$export$d47e946c43f3f3cc:
                return {
                    whatItIs: (0, $g8w56.default).burnupReportWhat,
                    howToReadIt: (0, $g8w56.default).burnupReportHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/reports-952607296.html'
                };
            case 0, $07d657390afa880f$export$c456b3f56f927707:
                return {
                    whatItIs: (0, $g8w56.default).velocityReportWhat,
                    howToReadIt: (0, $g8w56.default).velocityReportHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/velocity-report-next-gen-975029957.html'
                };
            case 0, $07d657390afa880f$export$1c3e2d262d98feed:
                return {
                    whatItIs: (0, $g8w56.default).cumulativeFlowWhat,
                    howToReadIt: (0, $g8w56.default).cumulativeFlowHow,
                    learnMoreLink: 'https://confluence.atlassian.com/jirasoftwarecloud/cumulative-flow-diagram-next-gen-975029954.html'
                };
            case 0, $07d657390afa880f$export$f42d2c00cd6e24b6:
                return {
                    whatItIs: (0, $g8w56.default).burndownWhat,
                    howToReadIt: (0, $g8w56.default).burndownHow,
                    learnMoreLink: 'https://confluence.atlassian.com/display/JIRASOFTWARECLOUD/Sprint+burndown+%28next-gen%29'
                };
            default:
                // Should not be reachable
                (0, $gUUjF.default).safeErrorWithoutCustomerData('software-reports.report-page.how-to', 'Unknown report type how-to requested.');
                return {
                    whatItIs: (0, $g8w56.default).whatItIs,
                    howToReadIt: (0, $g8w56.default).howToReadIt,
                    learnMoreLink: '#'
                };
        }
    }
    render() {
        const { intl: { formatMessage: formatMessage }, visible: visible, reportType: reportType } = this.props;
        const howToData = $f8f725212b9b9021$export$d2e991ab6448c561.getHowToDataForReportType(reportType);
        const learnMore = formatMessage((0, $g8w56.default).learnMore);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$HowToContainer, {
            visible: visible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$Gutter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $g8w56.default).whatItIs)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(howToData.whatItIs))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f8f725212b9b9021$var$Gutter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, formatMessage((0, $g8w56.default).howToReadIt)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...howToData.howToReadIt,
            values: {
                learnMore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5OdZ3.default), {
                    onClick: (e, analyticsEvent)=>{
                        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'report-page-learn-more');
                    },
                    target: "_blank",
                    href: howToData.learnMoreLink
                }, learnMore)
            }
        }))));
    }
}
var $f8f725212b9b9021$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($f8f725212b9b9021$export$d2e991ab6448c561);
const $f8f725212b9b9021$var$HowToContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visible: visible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1reo15vq _18m915vq _v564it2h _otyru2gc",
            __cmplp.visible ? "_c71l68cl" : "_c71lidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8f725212b9b9021$var$Gutter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1ssb _1yt4u2gc",
            __cmplp.className
        ])
    });
});

});
const $07d657390afa880f$export$c456b3f56f927707 = 'velocity';
const $07d657390afa880f$export$d47e946c43f3f3cc = 'burnup';
const $07d657390afa880f$export$f42d2c00cd6e24b6 = 'burndown';
const $07d657390afa880f$export$47b059c21f4ed074 = 'burnupChart';
const $07d657390afa880f$export$1c3e2d262d98feed = 'cumulative';
const $07d657390afa880f$export$d76071d5de2774fc = 'software.reports.report-page';

parcelRegister("g8w56", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b2297b9137441a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00b2297b9137441a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whatItIs: {
        "id": "software-reports-report-page.header.how-to.what-it-is",
        "defaultMessage": "What it is"
    },
    howToReadIt: {
        "id": "software-reports-report-page.header.how-to.how-to-read-it",
        "defaultMessage": "How to read it"
    },
    learnMore: {
        "id": "software-reports-report-page.header.how-to.learn-more",
        "defaultMessage": "Learn more"
    },
    burnupReportWhat: {
        "id": "software-reports-report-page.header.how-to.burnup-report-what",
        "defaultMessage": "Maintain your sprint's health by identifying problems such as scope creep or planned path deviation."
    },
    burnupReportHow: {
        "id": "software-reports-report-page.header.how-to.burnup-report-how",
        "defaultMessage": "The distance between lines is the amount of work remaining. Examine the Work scope line to identify scope creep. {learnMore}"
    },
    velocityReportWhat: {
        "id": "software-reports-report-page.header.how-to.velocity-report-what",
        "defaultMessage": "Your team's velocity is calculated by taking the average of the total completed estimates from their last few sprints."
    },
    velocityReportHow: {
        "id": "software-reports-report-page.header.how-to.velocity-report-how",
        "defaultMessage": "Grey: the total estimate of each sprint's issues when the sprint began. Green: the total completed estimates when the sprint ended. {learnMore}"
    },
    cumulativeFlowWhat: {
        "id": "software-reports-report-page.header.how-to.cumulative-flow-what",
        "defaultMessage": "Shows the statuses of issues over time. This helps you identify potential bottlenecks that need to be investigated."
    },
    cumulativeFlowHow: {
        "id": "software-reports-report-page.header.how-to.cumulative-flow-how",
        "defaultMessage": "The distance between each column lines shows you how long issues take to get from one state to another. Look for points where one band is growing at a faster rate than another to find bottlenecks. {learnMore}"
    },
    burndownWhat: {
        "id": "software-reports-report-page.header.how-to.burndown-what",
        "defaultMessage": "Shows the total work remaining for the current sprint, and the likelihood of your team completing the sprint on time. Also shows a summary of scope changes and work done throughout the sprint."
    },
    burndownHow: {
        "id": "software-reports-report-page.header.how-to.burndown-how",
        "defaultMessage": "The red line shows how much work remains in the sprint. The grey line shows the ideal progress rate. {learnMore}"
    }
});

});


parcelRegister("6VbGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f54379f215fdd1d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $giAhk = parcelRequire("giAhk");

var $g8JvH = parcelRequire("g8JvH");

var $8zGUB = parcelRequire("8zGUB");
const $1f54379f215fdd1d$var$HowToReadComponent = ({ onClick: onClick, intl: intl })=>// @ts-expect-error onClick event type doesn't match DOM event
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f54379f215fdd1d$var$HowToReadText, {
        onClick: onClick
    }, intl.formatMessage((0, $8zGUB.default).howToRead));
const $1f54379f215fdd1d$var$HowToReadComponentWithAnalytics = (0, $g8JvH.AnalyticsEventToProps)('reportPageHeader', {
    onClick: 'howToToggled'
})($1f54379f215fdd1d$var$HowToReadComponent);
var $1f54379f215fdd1d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($1f54379f215fdd1d$var$HowToReadComponentWithAnalytics);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f54379f215fdd1d$var$HowToReadText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1vl3 _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8zGUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b88c428a943039$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c8b88c428a943039$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    howToRead: {
        "id": "software-reports-report-page.header.how-to-read-text.how-to-read",
        "defaultMessage": "How to read this report"
    }
});

});


parcelRegister("78k8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $af73e53afc6d60ed$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");

var $3a8wJ = parcelRequire("3a8wJ");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $jWL8K = parcelRequire("jWL8K");


var $5pzzA = parcelRequire("5pzzA");
class $af73e53afc6d60ed$export$8b251419efc915eb extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onToggleHowToPane = (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'report-page-how-to', {
                isOpening: !this.state.showHowTo
            });
            this.setState({
                showHowTo: !this.state.showHowTo
            });
        };
        this.state = {
            showHowTo: false
        };
    }
    renderTitle() {
        const { intl: { formatMessage: formatMessage }, reportType: reportType } = this.props;
        if (reportType === (0, $07d657390afa880f$export$c456b3f56f927707)) return formatMessage((0, $5pzzA.default).velocityReportTitle);
        if (reportType === (0, $07d657390afa880f$export$d47e946c43f3f3cc)) return formatMessage((0, $5pzzA.default).burnupReportTitle);
        if (reportType === (0, $07d657390afa880f$export$1c3e2d262d98feed)) return formatMessage((0, $5pzzA.default).cumulativeFlowTitle);
        if (reportType === (0, $07d657390afa880f$export$f42d2c00cd6e24b6)) return formatMessage((0, $5pzzA.default).burndownTitle);
        return null;
    }
    render() {
        const { BreadcrumbRenderer: BreadcrumbRenderer, HowTo: HowTo, Chevron: Chevron, HowToReadText: HowToReadText, boardId: boardId } = this.props;
        const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadcrumbRenderer, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
            truncateTitle: true,
            breadcrumbs: breadcrumbs,
            actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$HowToReadContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
                onClick: this.onToggleHowToPane,
                showHowTo: this.state.showHowTo
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HowToReadText, {
                onClick: this.onToggleHowToPane
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInlineStart: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jWL8K.JswShareButton), {
                boardId: boardId
            })))
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$HeadingStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af73e53afc6d60ed$var$TruncatingTextStyle, null, this.renderTitle()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HowTo, {
            visible: this.state.showHowTo,
            reportType: this.props.reportType
        }));
    }
}
const $af73e53afc6d60ed$var$HeaderWithIntl = (0, $giAhk.injectIntlV2)($af73e53afc6d60ed$export$8b251419efc915eb);
var $af73e53afc6d60ed$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $af73e53afc6d60ed$var$HeaderWithIntl;
const $af73e53afc6d60ed$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af73e53afc6d60ed$var$HowToReadContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af73e53afc6d60ed$var$HeadingStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $af73e53afc6d60ed$var$TruncatingTextStyle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s _16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});
const $af73e53afc6d60ed$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4fkly",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("jWL8K", function(module, exports) {

$parcel$export(module.exports, "JswShareButton", () => $bcd52ee284d5eb3c$export$54c54e47ce207cc8);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $huI7r = parcelRequire("huI7r");

var $fQ7Iw = parcelRequire("fQ7Iw");

var $iSNkS = parcelRequire("iSNkS");

var $dWLk9 = parcelRequire("dWLk9");

var $5cwrp = parcelRequire("5cwrp");
const $bcd52ee284d5eb3c$var$REPORT_SHARE_CONTENT_TYPE = 'report';
const $bcd52ee284d5eb3c$export$54c54e47ce207cc8 = ({ boardId: boardId })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQ7Iw.default), {
        integrationType: (0, $iSNkS.integrationTypes).CLASSIC_BOARD,
        triggerButtonStyle: "icon-only",
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: formatMessage((0, $5cwrp.default).shareTitle),
        shareFormTitle: formatMessage((0, $5cwrp.default).shareFormTitle),
        shareContentType: $bcd52ee284d5eb3c$var$REPORT_SHARE_CONTENT_TYPE,
        objectAri: (0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }),
        copyTooltipText: formatMessage((0, $5cwrp.default).shareTooltipText),
        shareFormHelperMessage: formatMessage((0, $5cwrp.default).shareHelperMessage)
    });
};

});
parcelRegister("fQ7Iw", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $eb292e1f91805d5c$export$5619d05bf511476b);
$parcel$export(module.exports, "default", () => $eb292e1f91805d5c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $dFWNP = parcelRequire("dFWNP");


var $5GxEP = parcelRequire("5GxEP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $8nUKh = parcelRequire("8nUKh");
const $eb292e1f91805d5c$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFWNP))), {
            size: "medium",
            label: formatMessage((0, $8nUKh.messages).shareTriggerButtonText),
            primaryColor: `var(--ds-icon, ${(0, $73a5c9d720aa66e1$exports).N30})`
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $8nUKh.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $eb292e1f91805d5c$var$ShareButton = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("lUmmJ")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$eb292e1f91805d5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($eb292e1f91805d5c$var$ShareButton, props)));

});
parcelRegister("dFWNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f4cb7ac67043f68$var$_react = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9f4cb7ac67043f68$var$_share = $9f4cb7ac67043f68$var$_interopRequireDefault((parcelRequire("ec2xp")));
function $9f4cb7ac67043f68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f4cb7ac67043f68$var$ShareIcon = (props)=>/*#__PURE__*/ $9f4cb7ac67043f68$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $9f4cb7ac67043f68$var$_share.default
    }));
$9f4cb7ac67043f68$var$ShareIcon.displayName = 'ShareIcon';
var $9f4cb7ac67043f68$var$_default = module.exports.default = $9f4cb7ac67043f68$var$ShareIcon;

});
parcelRegister("ec2xp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::530cf6124b77e826fb9d0e1e695d5d78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a55427aa389adc57$var$_react = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a55427aa389adc57$var$_UNSAFE_baseNew = $a55427aa389adc57$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a55427aa389adc57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a55427aa389adc57$var$ShareIcon = (props)=>/*#__PURE__*/ $a55427aa389adc57$var$_react.default.createElement($a55427aa389adc57$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
    }, props));
$a55427aa389adc57$var$ShareIcon.displayName = 'ShareIcon';
var $a55427aa389adc57$var$_default = module.exports.default = $a55427aa389adc57$var$ShareIcon;

});


parcelRegister("8nUKh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c445af617ae0da86$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c445af617ae0da86$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("lUmmJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("2xQrm")
]).then(()=>parcelRequire('iHQJU'));

});


parcelRegister("iSNkS", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $60586429dc17d610$export$a7359bcfb0ca8e98);
const $60586429dc17d610$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments'
};

});

parcelRegister("5cwrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38ea6be0c7e8bc7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a38ea6be0c7e8bc7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    shareTitle: {
        "id": "software-report-header-common.share-button.share-title",
        "defaultMessage": "Report"
    },
    shareFormTitle: {
        "id": "software-report-header-common.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "software-report-header-common.share-button.share-tooltip-text",
        "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
    },
    shareHelperMessage: {
        "id": "software-report-header-common.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("5pzzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f33dc4ae0bc5d70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3f33dc4ae0bc5d70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    burnupReportTitle: {
        "id": "software-reports-report-page.header.burnup-report-title",
        "defaultMessage": "Burnup report"
    },
    velocityReportTitle: {
        "id": "software-reports-report-page.header.velocity-report-title",
        "defaultMessage": "Velocity report"
    },
    cumulativeFlowTitle: {
        "id": "software-reports-report-page.header.cumulative-flow-title",
        "defaultMessage": "Cumulative flow diagram"
    },
    burndownTitle: {
        "id": "software-reports-report-page.header.burndown-title",
        "defaultMessage": "Sprint burndown chart"
    },
    hideHowToRead: {
        "id": "software-reports-report-page.header.hide-how-to-read",
        "defaultMessage": "Hide report help"
    },
    beta: {
        "id": "software-reports-report-page.header.beta",
        "defaultMessage": "Beta"
    }
});

});



parcelRegister("a1jkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3824cc88f2ebd0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aTgXo = parcelRequire("aTgXo");

var $aYtGv = parcelRequire("aYtGv");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");

var $dmmMp = parcelRequire("dmmMp");
function $7e3824cc88f2ebd0$export$33aa3110c4070c17({ Header: Header, boardId: boardId, reportType: reportType, reportsUrl: reportsUrl, children: children, intl: intl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${reportType}ReportPage`,
        containerId: `${boardId}`,
        containerType: "board",
        objectId: reportType,
        objectType: "report",
        attributes: {
            boardId: boardId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: intl.formatMessage((0, $dmmMp.default).reportsBreadcrumbTitle),
            href: reportsUrl,
            type: 'reports'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e3824cc88f2ebd0$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, {
        reportType: reportType,
        boardId: boardId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7e3824cc88f2ebd0$var$Content, null, children))));
}
var $7e3824cc88f2ebd0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($7e3824cc88f2ebd0$export$33aa3110c4070c17);
const $7e3824cc88f2ebd0$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP), "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4t3i1l47 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $7e3824cc88f2ebd0$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _18m91wug _1yt4fkly",
            __cmplp.className
        ])
    });
});

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dmmMp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9287900086a8ffab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9287900086a8ffab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    reportsBreadcrumbTitle: {
        "id": "software-reports-report-page.reports-breadcrumb-title",
        "defaultMessage": "Reports"
    }
});

});




parcelRegister("9IKEm", function(module, exports) {

$parcel$export(module.exports, "QUICK_DATE_FILTER_PAST_WEEK", () => $0706aa44382aeeb4$export$95df0e1337ff09e4);
$parcel$export(module.exports, "QUICK_DATE_FILTER_PAST_2_WEEKS", () => $0706aa44382aeeb4$export$def596db88714e54);
$parcel$export(module.exports, "QUICK_DATE_FILTER_PAST_MONTH", () => $0706aa44382aeeb4$export$64156c3024edbd35);
$parcel$export(module.exports, "QUICK_DATE_FILTER_PAST_3_MONTHS", () => $0706aa44382aeeb4$export$229f33ccfdbdea0c);
$parcel$export(module.exports, "QUICK_DATE_FILTER_PAST_6_MONTHS", () => $0706aa44382aeeb4$export$67f44c3baa56d25f);
$parcel$export(module.exports, "QUICK_DATE_FILTER_ALL_TIME", () => $0706aa44382aeeb4$export$d7191f36bdc5ec22);
$parcel$export(module.exports, "QUICK_DATE_FILTER_CUSTOM", () => $0706aa44382aeeb4$export$c447b8594dd55b12);
$parcel$export(module.exports, "APP_ID", () => $0706aa44382aeeb4$export$d76071d5de2774fc);
$parcel$export(module.exports, "LOCATION", () => $0706aa44382aeeb4$export$87d0ca22edb7493a);
$parcel$export(module.exports, "COLORS", () => $0706aa44382aeeb4$export$56d196d2844d1ca1);
// TODO: https://product-fabric.atlassian.net/browse/DSP-3792

const $0706aa44382aeeb4$export$95df0e1337ff09e4 = 'past_week';
const $0706aa44382aeeb4$export$def596db88714e54 = 'past_2_weeks';
const $0706aa44382aeeb4$export$64156c3024edbd35 = 'past_month';
const $0706aa44382aeeb4$export$229f33ccfdbdea0c = 'past_3_months';
const $0706aa44382aeeb4$export$67f44c3baa56d25f = 'past_6_months';
const $0706aa44382aeeb4$export$d7191f36bdc5ec22 = 'all_time';
const $0706aa44382aeeb4$export$c447b8594dd55b12 = 'custom';
const $0706aa44382aeeb4$export$d76071d5de2774fc = 'software.reports.cfd';
const $0706aa44382aeeb4$export$87d0ca22edb7493a = 'cumulativeFlowDiagram';
const $0706aa44382aeeb4$var$N70 = [
    (0, $73a5c9d720aa66e1$exports).N70,
    (0, $73a5c9d720aa66e1$exports).N60
];
const $0706aa44382aeeb4$var$N200 = [
    (0, $73a5c9d720aa66e1$exports).N200,
    (0, $73a5c9d720aa66e1$exports).N100
];
const $0706aa44382aeeb4$var$P300 = [
    (0, $73a5c9d720aa66e1$exports).P300,
    (0, $73a5c9d720aa66e1$exports).P200
];
const $0706aa44382aeeb4$var$P200 = [
    (0, $73a5c9d720aa66e1$exports).P200,
    (0, $73a5c9d720aa66e1$exports).P100
];
const $0706aa44382aeeb4$var$T200 = [
    (0, $73a5c9d720aa66e1$exports).T200,
    (0, $73a5c9d720aa66e1$exports).T100
];
const $0706aa44382aeeb4$var$B100 = [
    (0, $73a5c9d720aa66e1$exports).B100,
    (0, $73a5c9d720aa66e1$exports).B75
];
const $0706aa44382aeeb4$var$Y100 = [
    (0, $73a5c9d720aa66e1$exports).Y100,
    (0, $73a5c9d720aa66e1$exports).Y75
];
const $0706aa44382aeeb4$var$Y200 = [
    (0, $73a5c9d720aa66e1$exports).Y200,
    (0, $73a5c9d720aa66e1$exports).Y100
];
const $0706aa44382aeeb4$var$G200 = [
    (0, $73a5c9d720aa66e1$exports).G200,
    (0, $73a5c9d720aa66e1$exports).G100
];
const $0706aa44382aeeb4$var$G300 = [
    (0, $73a5c9d720aa66e1$exports).G300,
    (0, $73a5c9d720aa66e1$exports).G200
];
const $0706aa44382aeeb4$export$cf7ef7cc0680b87e = [
    $0706aa44382aeeb4$var$N70,
    $0706aa44382aeeb4$var$N200,
    $0706aa44382aeeb4$var$P300,
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$d18746a04e868390 = [
    $0706aa44382aeeb4$var$N70,
    $0706aa44382aeeb4$var$N200,
    $0706aa44382aeeb4$var$P300,
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$31cb45d9b237dad3 = [
    $0706aa44382aeeb4$var$N70,
    $0706aa44382aeeb4$var$P300,
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$18faeaa1a16e643e = [
    $0706aa44382aeeb4$var$P300,
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$f9b38b9453bc8e0a = [
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$4a747255fa1c9b46 = [
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$Y200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$9d0070c3cd3568f4 = [
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$B100,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$e1241dfba3c361eb = [
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$T200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$ce2f73ed2bdc8174 = [
    $0706aa44382aeeb4$var$P200,
    $0706aa44382aeeb4$var$G300
];
const $0706aa44382aeeb4$export$56f197fb27b2a8a8 = [
    $0706aa44382aeeb4$var$P200
];
const $0706aa44382aeeb4$export$56d196d2844d1ca1 = {
    '0': [],
    '1': $0706aa44382aeeb4$export$56f197fb27b2a8a8,
    '2': $0706aa44382aeeb4$export$ce2f73ed2bdc8174,
    '3': $0706aa44382aeeb4$export$e1241dfba3c361eb,
    '4': $0706aa44382aeeb4$export$9d0070c3cd3568f4,
    '5': $0706aa44382aeeb4$export$4a747255fa1c9b46,
    '6': $0706aa44382aeeb4$export$f9b38b9453bc8e0a,
    '7': $0706aa44382aeeb4$export$18faeaa1a16e643e,
    '8': $0706aa44382aeeb4$export$31cb45d9b237dad3,
    '9': $0706aa44382aeeb4$export$d18746a04e868390,
    '10': $0706aa44382aeeb4$export$cf7ef7cc0680b87e
};

});

parcelRegister("7OVAa", function(module, exports) {

$parcel$export(module.exports, "default", () => $773d70366c16358b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $8yne0 = parcelRequire("8yne0");

var $9EHc8 = parcelRequire("9EHc8");

var $0cdA8 = parcelRequire("0cdA8");

var $SFoH6 = parcelRequire("SFoH6");

var $4ynBm = parcelRequire("4ynBm");

var $4Es8k = parcelRequire("4Es8k");

var $giAhk = parcelRequire("giAhk");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $7vf5z = parcelRequire("7vf5z");

var $eIp1n = parcelRequire("eIp1n");

var $i0Fyd = parcelRequire("i0Fyd");

var $94EW1 = parcelRequire("94EW1");

var $3YysV = parcelRequire("3YysV");

var $iJHZm = parcelRequire("iJHZm");

var $gd0Sp = parcelRequire("gd0Sp");

var $9IKEm = parcelRequire("9IKEm");

var $kaTTd = parcelRequire("kaTTd");

var $i2A1t = parcelRequire("i2A1t");

var $4eaJj = parcelRequire("4eaJj");

var $5b4Jf = parcelRequire("5b4Jf");

var $esTb1 = parcelRequire("esTb1");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $773d70366c16358b$var$LazyChart = (0, $7rh0R.lazy)(()=>(parcelRequire("1QlUY")), {
    ssr: false,
    moduleId: "./src/packages/software/reports/cumulative-flow-diagram/src/ui/chart/index.tsx"
});
const $773d70366c16358b$var$Chart = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "flag",
        packageName: "jiraReportsCumulativeFlowDiagram",
        id: "bundle-async-cumulative-flow-diagram-chart-lazy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cumulative-flow-diagram-chart-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($773d70366c16358b$var$LazyChart, props)));
const $773d70366c16358b$var$FullReport = ({ data: data, onExperienceSuccess: onExperienceSuccess })=>{
    (0, $eUqFw.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b4Jf.default), {
        isDisabled: false,
        lowerOpacity: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($773d70366c16358b$var$Chart, {
        filters: data.filters,
        data: data.chart
    }));
};
const $773d70366c16358b$var$CumulativeFlowDiagramView = ({ boardId: boardId, intl: intl })=>{
    // @ts-expect-error - TS7031 - Binding element 'refetch' implicitly has an 'any' type. | TS7031 - Binding element 'error' implicitly has an 'any' type. | TS7031 - Binding element 'loading' implicitly has an 'any' type. | TS7031 - Binding element 'data' implicitly has an 'any' type.
    const onDataChange = ({ refetch: refetch, error: error, loading: loading, data: data })=>{
        if (!loading && error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "cumulativeFlowDiagramError"
        }, (0, $3YysV.default)(error, (0, $9IKEm.LOCATION)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b4Jf.default), {
            isDisabled: true,
            lowerOpacity: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
            renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $SFoH6.default)),
            header: intl.formatMessage((0, $esTb1.default).fetchError),
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: ()=>{
                    refetch();
                }
            }, intl.formatMessage((0, $esTb1.default).retryOnError))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
            eventName: "cumulativeFlowDiagramReport failed"
        }));
        const sprintsFeature = !loading ? // @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type.
        data.features && data.features.find(({ key: key })=>key === 'SPRINTS') : undefined;
        const areSprintsEnabled = sprintsFeature && sprintsFeature.status === 'ENABLED';
        const boardFeatures = !loading && data.features && (0, $i0Fyd.getFeatureAnalyticsAttributes)(data.features);
        if (!data.chart || !data.filters) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b4Jf.default), {
            isDisabled: true,
            lowerOpacity: false
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $94EW1.default), null));
        if (!data.chart.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "cumulativeFlowDiagramEmptyState",
            attributes: {
                areSprintsEnabled: areSprintsEnabled,
                boardFeatures: {
                    ...boardFeatures
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5b4Jf.default), {
            isDisabled: true,
            lowerOpacity: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
            renderImage: (0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $4ynBm.default)),
            header: intl.formatMessage((0, $esTb1.default).emptyReportHeader),
            description: intl.formatMessage((0, $esTb1.default).emptyReportDescription)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
            ttrSlo: 8000,
            ttiSlo: 8000,
            appName: "software-reports-cumulative-flow-diagram",
            extra: {
                isSentryEnabled: String((0, $kaTTd.isErrorTrackingEnabledWithSentry)()),
                synthetic: (0, $kaTTd.isPollinatorTenant)()
            },
            isExpectedToHaveSsr: false,
            // @ts-expect-error - TS2769 - No overload matches this call.
            metric: (0, $4eaJj.cumulativeFlowDiagramPageLoad)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            attributes: {
                areSprintsEnabled: areSprintsEnabled,
                boardFeatures: {
                    ...boardFeatures
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
            location: (0, $9IKEm.LOCATION),
            failureEventAttributes: {}
        }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($773d70366c16358b$var$FullReport, {
                data: data,
                onExperienceSuccess: onExperienceSuccess
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
            experience: "viewCumulativeFlowDiagram",
            analyticsSource: (0, $9IKEm.LOCATION),
            edition: tenantContext.appEditions.software,
            application: (0, $eIp1n.JIRA_SOFTWARE),
            additionalAttributes: {
                synthetic: (0, $kaTTd.isPollinatorTenant)()
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "cumulativeFlowDiagramReport",
            containerId: `${boardId}`,
            containerType: "board",
            objectId: (0, $9IKEm.LOCATION),
            objectType: "report",
            attributes: {
                boardId: boardId,
                isAdmin: tenantContext.isAdmin,
                isSiteAdmin: tenantContext.isSiteAdmin
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2A1t.default), {
            variables: {
                boardId: boardId
            }
        }, onDataChange))));
};
/* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ const $773d70366c16358b$var$CumulativeFlowDiagramViewWithIntl = (0, $giAhk.injectIntlV2)($773d70366c16358b$var$CumulativeFlowDiagramView);
var $773d70366c16358b$export$2e2bcd8739ae039 = $773d70366c16358b$var$CumulativeFlowDiagramViewWithIntl;

});
parcelRegister("SFoH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $88dd63a378373614$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $8E7L8 = parcelRequire("8E7L8");
const $88dd63a378373614$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8E7L8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8E7L8)),
    autoDark: false
});
var $88dd63a378373614$export$2e2bcd8739ae039 = $88dd63a378373614$var$Illustration;
// for advanced use only
const $88dd63a378373614$export$a179c88182cb9d56 = [
    0,
    0,
    277,
    263
];

});
parcelRegister("8E7L8", function(module, exports) {
module.exports = new URL("icecream-accident.69b5c609.svg", import.meta.url).toString();

});


parcelRegister("4ynBm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c40a49292b96475$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $86rZ0 = parcelRequire("86rZ0");
const $1c40a49292b96475$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($86rZ0)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($86rZ0))
});
var $1c40a49292b96475$export$2e2bcd8739ae039 = $1c40a49292b96475$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $1c40a49292b96475$export$a179c88182cb9d56 = [
    0,
    0,
    246,
    157
];

});
parcelRegister("86rZ0", function(module, exports) {
module.exports = new URL("cumulative-flow-diagram.6aa106f9.svg", import.meta.url).toString();

});


parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("i0Fyd", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $01278e875bedc0a0$export$ac70e171fbeaebce);
const $01278e875bedc0a0$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $01278e875bedc0a0$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$01278e875bedc0a0$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});

parcelRegister("3YysV", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $a40137074e874fc9$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $a40137074e874fc9$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $a40137074e874fc9$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $a40137074e874fc9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $iH6c1 = parcelRequire("iH6c1");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $lB25E = parcelRequire("lB25E");

var $cdFlB = parcelRequire("cdFlB");

var $8QSkp = parcelRequire("8QSkp");

var $6rUGr = parcelRequire("6rUGr");

var $abbBt = parcelRequire("abbBt");

const $a40137074e874fc9$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReasonWithStatusCode)((0, $e052d5702b12477c$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $a40137074e874fc9$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $a40137074e874fc9$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $a40137074e874fc9$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(error.message) && !!$a40137074e874fc9$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $a40137074e874fc9$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $a40137074e874fc9$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($a40137074e874fc9$export$34bc86f6bf17f1e0(errorResponse)) return 0, $e052d5702b12477c$export$3c39b2049cd1acb3;
    if ($a40137074e874fc9$export$8a5d666d6e5b82fc(errorResponse)) return 0, $e052d5702b12477c$export$fdfe3175a0c7be80;
    if ((0, $JRB5w.isClientFetchError)(errorResponse)) return 0, $e052d5702b12477c$export$38fe4329f59f7ac5;
    if ((0, $1ybV0.ff)('jsw.cmp.response-null-abort') && $a40137074e874fc9$export$7193151b5738a995(errorResponse)) return 0, $e052d5702b12477c$export$49d11848b43d6dbf;
    if ($a40137074e874fc9$export$ed0f33c09abc69f3(errorResponse)) return 0, $e052d5702b12477c$export$32e56551129a1642;
    return null;
};
const $a40137074e874fc9$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $6rUGr.extractStatusCode)(errorResponse);
    const abortFailureReason = $a40137074e874fc9$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $8QSkp.extractTraceId)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const hash = (0, $iH6c1.getErrorHash)(errorResponse) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(window, [
        'BUILD_KEY'
    ]) || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $e052d5702b12477c$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $e052d5702b12477c$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash,
            isBacklogWithRelayEnabled: (0, $cdFlB.isBacklogWithRelayEnabled)()
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // 40x missing permission, experience does not exist, not logged in, etc
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $abbBt.createFailureReason)((0, $e052d5702b12477c$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/projects?showFlag=jsw.project-not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $a40137074e874fc9$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $a40137074e874fc9$export$2e2bcd8739ae039 = $a40137074e874fc9$var$responseToSla;

});
parcelRegister("cdFlB", function(module, exports) {

$parcel$export(module.exports, "isBacklogWithRelayEnabled", () => $1432a1708fd01450$export$bc84f8a9593e9b2c);

var $1ybV0 = parcelRequire("1ybV0");
const $1432a1708fd01450$export$bc84f8a9593e9b2c = ()=>(0, $1ybV0.ff)('jsw.perf.critical-backlog-with-relay');

});

parcelRegister("8QSkp", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $d4638007eaa5c85e$export$431eacb6aecbacdf);
const $d4638007eaa5c85e$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("6rUGr", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $9a98a294942c3212$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $9a98a294942c3212$export$1fdf7c1c0741a7e7);

var $illlw = parcelRequire("illlw");

var $cD8SO = parcelRequire("cD8SO");
const $9a98a294942c3212$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($cD8SO)))(statusCodes);
    return statusCode || null;
};
const $9a98a294942c3212$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $9a98a294942c3212$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("cD8SO", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $bOiiU = parcelRequire("bOiiU");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $932004927d7c326a$var$max(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $bOiiU) : undefined;
}
module.exports = $932004927d7c326a$var$max;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("bOiiU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $899290031a4184bf$var$baseGt(value, other) {
    return value > other;
}
module.exports = $899290031a4184bf$var$baseGt;

});



parcelRegister("abbBt", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $3789a68bf3687ffa$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $3789a68bf3687ffa$export$cc7dce678df87fe9);
const $3789a68bf3687ffa$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $3789a68bf3687ffa$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $e052d5702b12477c$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $e052d5702b12477c$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $e052d5702b12477c$export$7b9f56c34c008ec2 = '429-error';
const $e052d5702b12477c$export$3c39b2049cd1acb3 = 'user-network-error';
const $e052d5702b12477c$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $e052d5702b12477c$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $e052d5702b12477c$export$49d11848b43d6dbf = 'response-null-error';
const $e052d5702b12477c$export$32e56551129a1642 = 'client-third-party-app-error';
const $e052d5702b12477c$export$fa14a20fcf1b1eb4 = 'unknown';


parcelRegister("kaTTd", function(module, exports) {

$parcel$export(module.exports, "isErrorTrackingEnabledWithSentry", () => $04e6a7566075de4d$export$23d600ca6d887b4d);
$parcel$export(module.exports, "isPollinatorTenant", () => $04e6a7566075de4d$export$f59b7b56b5cada61);

var $1ybV0 = parcelRequire("1ybV0");
const $04e6a7566075de4d$export$23d600ca6d887b4d = ()=>(0, $1ybV0.ff)('fe.platform.error.tracking.enabled');
const $04e6a7566075de4d$export$f59b7b56b5cada61 = ()=>(0, $1ybV0.ff)('jsw.pollinator.tenants');

});

parcelRegister("i2A1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1f6e8eab979cb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ipS98 = parcelRequire("ipS98");

var $9ypom = parcelRequire("9ypom");
const $fb1f6e8eab979cb5$export$fc02702da1b1fadf = (connection)=>{
    const { edges: edges } = connection;
    return edges.map((edge)=>edge.node);
};
const $fb1f6e8eab979cb5$export$d6d5466eed639407 = (0, $9ypom.default)`
    query CFDReport($boardId: ID!) {
        boardScope(boardId: $boardId) {
            features {
                key
                status
            }
            reports {
                cumulativeFlowDiagram {
                    chart {
                        edges {
                            node {
                                timestamp
                                changes {
                                    key
                                    columnFrom
                                    columnTo
                                    statusTo
                                }

                                columnCounts {
                                    columnIndex
                                    count
                                }
                            }
                        }
                    }

                    filters {
                        columns {
                            name
                        }
                    }
                }
            }
        }
    }
`;
const $fb1f6e8eab979cb5$var$EMPTY_DATA = Object.freeze({});
/**
 * Apollo query for the CFD report data.
 */ const $fb1f6e8eab979cb5$var$CFDQuery = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipS98.Query), {
        ...props,
        query: $fb1f6e8eab979cb5$export$d6d5466eed639407,
        fetchPolicy: "cache-and-network"
    }, ({ data: data, error: error, refetch: refetch, loading: loading })=>{
        const boardScope = data && data.boardScope;
        if (boardScope) return children({
            error: error,
            loading: loading,
            refetch: refetch,
            data: {
                filters: boardScope.reports.cumulativeFlowDiagram.filters,
                chart: $fb1f6e8eab979cb5$export$fc02702da1b1fadf(boardScope.reports.cumulativeFlowDiagram.chart),
                features: boardScope.features
            }
        });
        return children({
            data: $fb1f6e8eab979cb5$var$EMPTY_DATA,
            error: error,
            refetch: refetch,
            loading: loading
        });
    });
var $fb1f6e8eab979cb5$export$2e2bcd8739ae039 = $fb1f6e8eab979cb5$var$CFDQuery;

});
parcelRegister("ipS98", function(module, exports) {

$parcel$export(module.exports, "Query", () => $d684901c79534e6a$export$62297b13309008b2);


var $fKE23 = parcelRequire("fKE23");

var $wLG4P = parcelRequire("wLG4P");

var $1Qivz = parcelRequire("1Qivz");
function $d684901c79534e6a$export$62297b13309008b2(props) {
    var children = props.children, query = props.query, options = (0, $fKE23.__rest)(props, [
        "children",
        "query"
    ]);
    var result = (0, $wLG4P.useQuery)(query, options);
    return children && result ? children(result) : null;
}
(function(Query) {
    Query.propTypes = {
        client: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        notifyOnNetworkStatusChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        pollInterval: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        query: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        ssr: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        partialRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        returnPartialData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
    };
})($d684901c79534e6a$export$62297b13309008b2 || ($d684901c79534e6a$export$62297b13309008b2 = {}));
function $d684901c79534e6a$export$17b8b19c814bcf56(props) {
    var _a = (0, $wLG4P.useMutation)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function(Mutation) {
    Mutation.propTypes = {
        mutation: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        optimisticResponse: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        refetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
                (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
        ]),
        awaitRefetchQueries: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        update: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        fetchPolicy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    };
})($d684901c79534e6a$export$17b8b19c814bcf56 || ($d684901c79534e6a$export$17b8b19c814bcf56 = {}));
function $d684901c79534e6a$export$f55210826850c514(props) {
    var result = (0, $wLG4P.useSubscription)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function(Subscription) {
    Subscription.propTypes = {
        subscription: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        variables: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onSubscriptionData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onSubscriptionComplete: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        shouldResubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
        ])
    };
})($d684901c79534e6a$export$f55210826850c514 || ($d684901c79534e6a$export$f55210826850c514 = {}));

});
parcelRegister("wLG4P", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $0627f9105c9a9319$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useMutation", () => $0627f9105c9a9319$export$609860bf8b0084c);
$parcel$export(module.exports, "useSubscription", () => $0627f9105c9a9319$export$368b4214baeb914c);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $0627f9105c9a9319$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $0627f9105c9a9319$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, $fKE23.__assign)({
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        var _a, _b;
        if (this.ssrInitiated()) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 || _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.onNewData();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $0627f9105c9a9319$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    var queryData = queryDataRef.current || new $0627f9105c9a9319$var$QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $0627f9105c9a9319$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}
function $0627f9105c9a9319$export$dd0a697e1782aedd(query, options) {
    return $0627f9105c9a9319$var$useBaseQuery(query, options, false);
}
function $0627f9105c9a9319$export$fd83eea6ecd2d8fa(query, options) {
    return $0627f9105c9a9319$var$useBaseQuery(query, options, true);
}
var $0627f9105c9a9319$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $0627f9105c9a9319$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $0627f9105c9a9319$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($0627f9105c9a9319$var$OperationData);
function $0627f9105c9a9319$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $0627f9105c9a9319$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $0627f9105c9a9319$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $0627f9105c9a9319$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $0627f9105c9a9319$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $0627f9105c9a9319$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("4eaJj", function(module, exports) {

$parcel$export(module.exports, "cumulativeFlowDiagramPageLoad", () => $0b75ae904321dcbf$export$aeb0b55523b86626);

var $lNfG4 = parcelRequire("lNfG4");
const $0b75ae904321dcbf$export$aeb0b55523b86626 = (0, $lNfG4.metrics).pageLoad({
    key: 'software-reports.cumulative-flow-diagram',
    slo: {
        fmp: {
            initial: {
                threshold: 8000
            },
            transition: {
                threshold: 8000
            }
        },
        tti: {
            initial: {
                threshold: 8000
            },
            transition: {
                threshold: 8000
            }
        }
    }
});

});

parcelRegister("5b4Jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7099cea0bc66085d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lQPrJ = parcelRequire("lQPrJ");

var $frBYx = parcelRequire("frBYx");
const $7099cea0bc66085d$var$ConnectedControls = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQPrJ.UiStateSubscriber), null, (state, actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $frBYx.default), {
            ...props,
            quickDateFilter: state.quickFilter,
            zoomState: state.zoomState,
            // @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: QUICK_DATE_FILTER) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [QUICK_DATE_FILTER]>'.
            setQuickDateFilter: actions.setQuickDateFilter,
            // @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: Date | null) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [Date | null]>'.
            setZoomStartDate: actions.setZoomStartDate,
            // @ts-expect-error - TS2741 - Property 'pure' is missing in type '(args_0: Date | null) => void | Promise<void>' but required in type 'ConvertedActionCreator<UiState, [Date | null]>'.
            setZoomEndDate: actions.setZoomEndDate
        }));
var $7099cea0bc66085d$export$2e2bcd8739ae039 = $7099cea0bc66085d$var$ConnectedControls;

});
parcelRegister("lQPrJ", function(module, exports) {

$parcel$export(module.exports, "UiStateSubscriber", () => $6fd054da71991691$export$b81c63726e4e23c3);

var $WBLbN = parcelRequire("WBLbN");

var $9IKEm = parcelRequire("9IKEm");

var $eKEBo = parcelRequire("eKEBo");
const $6fd054da71991691$export$d4c72bab9d6cc13a = {
    zoomState: {
        type: 'none'
    },
    quickFilter: (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME)
};
const $6fd054da71991691$export$390f32400eaf98c9 = (0, $WBLbN.createStore)({
    name: '@cumulative-flow-diagram/ui',
    initialState: $6fd054da71991691$export$d4c72bab9d6cc13a,
    actions: $eKEBo
});
const $6fd054da71991691$export$b81c63726e4e23c3 = (0, $WBLbN.createSubscriber)($6fd054da71991691$export$390f32400eaf98c9);

});
parcelRegister("eKEBo", function(module, exports) {

$parcel$export(module.exports, "setZoomState", () => $b9a60c0435a8b944$export$64bad6ef0d42f82c);
$parcel$export(module.exports, "setZoomStartDate", () => $b9a60c0435a8b944$export$f7f6cbc07969a731);
$parcel$export(module.exports, "setZoomEndDate", () => $b9a60c0435a8b944$export$278e6193e0f2641f);
$parcel$export(module.exports, "setQuickDateFilter", () => $b9a60c0435a8b944$export$17c377055a8a957f);

var $9IKEm = parcelRequire("9IKEm");

var $cXzWv = parcelRequire("cXzWv");

var $aneXZ = parcelRequire("aneXZ");
const $b9a60c0435a8b944$export$64bad6ef0d42f82c = (0, $cXzWv.default)((zoomState)=>()=>{
        const quickFilter = zoomState.type === 'percentage' && zoomState.start === 0 && zoomState.end === 100 ? (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME) : (0, $9IKEm.QUICK_DATE_FILTER_CUSTOM);
        return {
            zoomState: zoomState,
            quickFilter: quickFilter
        };
    });
const $b9a60c0435a8b944$export$f7f6cbc07969a731 = (0, $cXzWv.default)((start)=>(state)=>{
        // @ts-expect-error - TS2339 - Property 'endValue' does not exist on type 'ZoomState'.
        if (state.zoomState.endValue == null && start == null) return {
            zoomState: {
                type: 'none'
            },
            quickFilter: (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME)
        };
        return {
            zoomState: {
                type: 'value',
                startValue: start != null ? start.getTime() : null,
                endValue: // @ts-expect-error - TS2339 - Property 'endValue' does not exist on type 'ZoomState'. | TS2339 - Property 'endValue' does not exist on type 'ZoomState'.
                state.zoomState.endValue != null ? state.zoomState.endValue : new Date().getTime()
            },
            quickFilter: (0, $9IKEm.QUICK_DATE_FILTER_CUSTOM)
        };
    });
const $b9a60c0435a8b944$export$278e6193e0f2641f = (0, $cXzWv.default)((end)=>(state)=>{
        // @ts-expect-error - TS2339 - Property 'startValue' does not exist on type 'ZoomState'.
        if (state.zoomState.startValue == null && end == null) return {
            zoomState: {
                type: 'none'
            },
            quickFilter: (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME)
        };
        return {
            zoomState: {
                type: 'value',
                // @ts-expect-error - TS2339 - Property 'startValue' does not exist on type 'ZoomState'. | TS2339 - Property 'startValue' does not exist on type 'ZoomState'.
                startValue: state.zoomState.startValue != null ? state.zoomState.startValue : null,
                endValue: end != null ? end.getTime() : null
            },
            quickFilter: (0, $9IKEm.QUICK_DATE_FILTER_CUSTOM)
        };
    });
const $b9a60c0435a8b944$export$17c377055a8a957f = (0, $cXzWv.default)((quickFilter)=>(state)=>({
            quickFilter: quickFilter,
            zoomState: (0, $aneXZ.getQuickDateFilterZoomState)(state.zoomState, quickFilter, new Date())
        }));

});
parcelRegister("cXzWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $893c22a6f5ee5b53$export$2e2bcd8739ae039);
/**
 * Turns a pure state transformation creator into a react-sweet-state Action creator.
 *
 * For example:
 *     type State = {| counter: number |};
 *
 *     const increment = pureAction<State, [number]>(inc => state => ({
 *         counter: state.counter + inc,
 *     });
 *
 * The function returned by `pureAction` has the correct type:
 *
 *     (inc: number) => Action<State>
 *
 * And exposes the pure transformation creator in its `.pure` property for testing:
 *
 *     const initialState = { counter: 0 };
 *     const incrementedState = increment.pure(10)(initialState);
 *
 */ const $893c22a6f5ee5b53$var$pureAction = (actionCreator)=>{
    const convertedActionCreator = (...parameters)=>{
        const action = actionCreator(...parameters);
        return ({ getState: getState, setState: setState })=>{
            const state = getState();
            const newPartialState = action(state);
            return setState(newPartialState);
        };
    };
    convertedActionCreator.pure = actionCreator;
    return convertedActionCreator;
};
var $893c22a6f5ee5b53$export$2e2bcd8739ae039 = $893c22a6f5ee5b53$var$pureAction;

});

parcelRegister("aneXZ", function(module, exports) {

$parcel$export(module.exports, "getQuickDateFilterZoomState", () => $170b50ef6a39afaa$export$102f4ce3102f2ab5);

var $gyu6c = parcelRequire("gyu6c");

var $9IKEm = parcelRequire("9IKEm");
const $170b50ef6a39afaa$export$241c6e5dcf53bf36 = (quickDateFilter)=>{
    switch(quickDateFilter){
        case 0, $9IKEm.QUICK_DATE_FILTER_PAST_WEEK:
            return {
                weeks: -1
            };
        case 0, $9IKEm.QUICK_DATE_FILTER_PAST_2_WEEKS:
            return {
                weeks: -2
            };
        case 0, $9IKEm.QUICK_DATE_FILTER_PAST_MONTH:
            return {
                months: -1
            };
        case 0, $9IKEm.QUICK_DATE_FILTER_PAST_3_MONTHS:
            return {
                months: -3
            };
        case 0, $9IKEm.QUICK_DATE_FILTER_PAST_6_MONTHS:
            return {
                months: -6
            };
        default:
            return {
                months: 0,
                weeks: 0
            };
    }
};
const $170b50ef6a39afaa$export$102f4ce3102f2ab5 = (currentZoomState, quickDateFilter, now)=>{
    if (quickDateFilter === (0, $9IKEm.QUICK_DATE_FILTER_CUSTOM)) return currentZoomState;
    if (quickDateFilter === (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME)) return {
        type: 'none'
    };
    const timeDiff = $170b50ef6a39afaa$export$241c6e5dcf53bf36(quickDateFilter);
    const toDate = now;
    const fromDate = (0, $gyu6c.default)(toDate, timeDiff);
    return {
        type: 'value',
        startValue: fromDate.getTime(),
        endValue: toDate.getTime()
    };
};

});



parcelRegister("frBYx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dd05751adc3c708$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $jXg8H = parcelRequire("jXg8H");

var $8n1le = parcelRequire("8n1le");

var $giAhk = parcelRequire("giAhk");

var $jMP2a = parcelRequire("jMP2a");

var $gkHn1 = parcelRequire("gkHn1");

var $5TwAy = parcelRequire("5TwAy");

var $fkqVe = parcelRequire("fkqVe");
// eslint-disable-next-line jira/react/no-class-components
class $3dd05751adc3c708$var$Controls extends (0, $eUqFw.Component) {
    render() {
        const { intl: intl, isDisabled: isDisabled, lowerOpacity: lowerOpacity, zoomState: zoomState, quickDateFilter: quickDateFilter } = this.props;
        const derivedState = (0, $fkqVe.getControlsStateFromZoom)(zoomState, quickDateFilter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlsContainer, {
            lowerOpacity: lowerOpacity
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlLabel, {
            htmlFor: "cfd-quick-date-filter"
        }, intl.formatMessage((0, $5TwAy.default).dateFilterLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8n1le.default), {
            isDisabled: isDisabled,
            id: "cfd-quick-date-filter",
            "aria-label": intl.formatMessage((0, $5TwAy.default).dateFilterLabel),
            value: derivedState.selectedOption,
            onChange: this.onChangeQuickDateFilter,
            options: (0, $gkHn1.QUICK_DATE_FILTER_OPTIONS)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlLabel, {
            htmlFor: "cfd-from-date"
        }, intl.formatMessage((0, $5TwAy.default).fromDateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
            id: "cfd-from-date",
            isDisabled: isDisabled,
            // @ts-expect-error - TS2322 - Type '(value: string, analyticsEvent: any) => void' is not assignable to type '((value: string) => void) & ((value: string) => void)'.
            onChange: this.onChangeFrom
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3dd05751adc3c708$var$ControlLabel, {
            htmlFor: "cfd-to-date"
        }, intl.formatMessage((0, $5TwAy.default).toDateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
            id: "cfd-to-date",
            isDisabled: isDisabled,
            onChange: this.onChangeTo
        })));
    }
    constructor(...args){
        super(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChangeFrom = (value, analyticsEvent)=>{
            const { quickDateFilter: quickDateFilter, zoomState: zoomState } = this.props;
            const derivedState = (0, $fkqVe.getControlsStateFromZoom)(zoomState, quickDateFilter);
            const toDate = new Date(derivedState.toDate);
            let date = value ? (0, $fkqVe.parseDatePickerDate)(value) : null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(date)) {
                if (date.getTime() > toDate.getTime()) date = toDate;
                else if (date.getTime() > new Date().getTime()) date = new Date();
            }
            this.props.setZoomStartDate(date);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dateFilter', {
                from: derivedState.fromDate,
                to: value,
                label: 'From date',
                currentState: derivedState
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChangeTo = (value, analyticsEvent)=>{
            const { quickDateFilter: quickDateFilter, zoomState: zoomState } = this.props;
            const derivedState = (0, $fkqVe.getControlsStateFromZoom)(zoomState, quickDateFilter);
            const fromDate = new Date(derivedState.fromDate);
            let date = value ? (0, $fkqVe.parseDatePickerDate)(value) : null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(date)) {
                if (date.getTime() < fromDate.getTime()) date = fromDate;
                else if (date.getTime() > new Date().getTime()) date = new Date();
            }
            this.props.setZoomEndDate(date);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dateFilter', {
                from: derivedState.toDate,
                to: value,
                label: 'To date',
                currentState: derivedState
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChangeQuickDateFilter = (option, action, analyticsEvent)=>{
            const { quickDateFilter: quickDateFilter, zoomState: zoomState } = this.props;
            const derivedState = (0, $fkqVe.getControlsStateFromZoom)(zoomState, quickDateFilter);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dateFilter', {
                from: derivedState.selectedOption,
                to: option,
                label: 'Date filter',
                currentState: derivedState
            });
            this.props.setQuickDateFilter(option.value);
        };
    }
}
const $3dd05751adc3c708$var$ControlsWithIntl = (0, $giAhk.injectIntlV2)($3dd05751adc3c708$var$Controls);
var $3dd05751adc3c708$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3dd05751adc3c708$var$ControlsWithIntl;
const $3dd05751adc3c708$var$ControlsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { lowerOpacity: lowerOpacity, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564a7xe",
            __cmplp.lowerOpacity ? "_tzy41ou4" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $3dd05751adc3c708$var$ControlContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _p12f1lit _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $3dd05751adc3c708$var$ControlLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _1yt4sz9k _syaznoz8 _11c81vlj _k48pni7l _vwz47vkz _19pkpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $aYOOX = parcelRequire("aYOOX");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = "platform-pkg";
const $a38f1e4301a686fa$var$packageVersion = "0.0.0-use.local";
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{}
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value;
        this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
        this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $aYOOX.getParsedISO)({
                    iso: iso
                })
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false
                });
                this.props.onBlur(event);
            }
        };
        this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $aYOOX.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                });
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $aYOOX.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        // `unknown` is used because `value` is unused so it does not matter.
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, disabled: disabled, disabledDateFilter: disabledDateFilter, hideIcon: hideIcon = false, icon: // TODO: Resolve this typing to be more intuitive
        icon = (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $aYOOX.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null;
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            appearance: this.props.appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            menuIsOpen: menuIsOpen,
            onBlur: this.onSelectBlur,
            onChange: this.onSelectChange,
            onFocus: this.onSelectFocus,
            onInputChange: this.handleSelectInputChange,
            placeholder: (0, $aYOOX.getPlaceholder)({
                placeholder: this.props.placeholder,
                l10n: this.state.l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            // These are below the spread because I don't know what is in
            // selectProps or not and what wil be overwritten
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            // These aren't part of `Select`'s API, but we're using them here.
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        })));
    }
}
/**
 * __Date picker__
 *
 * A date picker allows the user to select a particular date.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
 */ const $a38f1e4301a686fa$var$DatePicker = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = $a38f1e4301a686fa$var$DatePicker;

});
parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $f21a4850a620a60b$var$_calendar = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("61UUs")));
function $f21a4850a620a60b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $f21a4850a620a60b$var$_calendar.default
    }));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = module.exports.default = $f21a4850a620a60b$var$CalendarIcon;

});
parcelRegister("61UUs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db9feac5032e1f6cb5923640df1c100>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $463efb2573c58501$var$_react = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $463efb2573c58501$var$_UNSAFE_baseNew = $463efb2573c58501$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $463efb2573c58501$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $463efb2573c58501$var$CalendarIcon = (props)=>/*#__PURE__*/ $463efb2573c58501$var$_react.default.createElement($463efb2573c58501$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
    }, props));
$463efb2573c58501$var$CalendarIcon.displayName = 'CalendarIcon';
var $463efb2573c58501$var$_default = module.exports.default = $463efb2573c58501$var$CalendarIcon;

});


parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});


parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("aYOOX", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $be48f7c2ad85fcf1$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $be48f7c2ad85fcf1$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $be48f7c2ad85fcf1$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $be48f7c2ad85fcf1$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $EN9B6 = parcelRequire("EN9B6");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $jP55W = parcelRequire("jP55W");

var $7i5dr = parcelRequire("7i5dr");
const $be48f7c2ad85fcf1$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $be48f7c2ad85fcf1$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
    return newIso;
};
const $be48f7c2ad85fcf1$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
    return l10n.parseDate(date);
};
const $be48f7c2ad85fcf1$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
    const date = (0, $3xcI8.default)(value);
    return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $be48f7c2ad85fcf1$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $7i5dr.placeholderDatetime));
};

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $knRXm = parcelRequire("knRXm");


var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $c845995965375b9a$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $3xcI8.default)(iso);
        return (0, $7ueqz.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $73a5c9d720aa66e1$export$d2d3bedfb276cac0)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
    const { day: day, month: month, year: year } = $c845995965375b9a$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $knRXm.UNSAFE_LAYERING), {
        isDisabled: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            day: day,
            month: month,
            year: year,
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            selected: [
                selectProps.calendarValue
            ],
            shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));
};

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $ki32l.useId)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $ki32l = parcelRequire("ki32l");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $ki32l.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`,
            color: `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$7090862dc3038a9f})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)()
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
            theme: theme
        }, children);
    };

});


parcelRegister("8n1le", function(module, exports) {

$parcel$export(module.exports, "default", () => $be0cbf1c58990d80$export$2e2bcd8739ae039);

var $5wCDk = parcelRequire("5wCDk");

var $eGI9v = parcelRequire("eGI9v");
const $be0cbf1c58990d80$var$SelectWithAnalytics = (0, $eGI9v.default)('select', {
    onChange: 'changed'
})((0, $5wCDk.default));
var $be0cbf1c58990d80$export$2e2bcd8739ae039 = $be0cbf1c58990d80$var$SelectWithAnalytics;

});

parcelRegister("gkHn1", function(module, exports) {

$parcel$export(module.exports, "QUICK_DATE_FILTER_OPTIONS", () => $133af8e8b0013272$export$ad87f38ca30860e8);
$parcel$export(module.exports, "QUICK_DATE_FILTER_LABELS_BY_VALUE", () => $133af8e8b0013272$export$c6033981cff8b761);

var $3aUuh = parcelRequire("3aUuh");

var $9IKEm = parcelRequire("9IKEm");
const $133af8e8b0013272$export$ad87f38ca30860e8 = [
    {
        label: 'Past Week',
        value: (0, $9IKEm.QUICK_DATE_FILTER_PAST_WEEK)
    },
    {
        label: 'Past 2 Weeks',
        value: (0, $9IKEm.QUICK_DATE_FILTER_PAST_2_WEEKS)
    },
    {
        label: 'Past Month',
        value: (0, $9IKEm.QUICK_DATE_FILTER_PAST_MONTH)
    },
    {
        label: 'Past 3 Months',
        value: (0, $9IKEm.QUICK_DATE_FILTER_PAST_3_MONTHS)
    },
    {
        label: 'Past 6 Months',
        value: (0, $9IKEm.QUICK_DATE_FILTER_PAST_6_MONTHS)
    },
    {
        label: 'All Time',
        value: (0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME)
    }
];
const $133af8e8b0013272$export$2e8652fe87840df7 = [
    ...$133af8e8b0013272$export$ad87f38ca30860e8,
    {
        label: 'Custom dates',
        value: (0, $9IKEm.QUICK_DATE_FILTER_CUSTOM)
    }
];
const $133af8e8b0013272$export$c6033981cff8b761 = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))($133af8e8b0013272$export$2e8652fe87840df7, 'value');

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});


parcelRegister("5TwAy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d22ff3171a5b4f16$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $d22ff3171a5b4f16$var$messages = (0, $90IgZ.defineMessages)({
    dateFilterLabel: {
        "id": "software-reports-cumulative-flow-diagram.controls.date-filter-label",
        "defaultMessage": "Date filter"
    },
    fromDateLabel: {
        "id": "software-reports-cumulative-flow-diagram.controls.from-date-label",
        "defaultMessage": "From date"
    },
    toDateLabel: {
        "id": "software-reports-cumulative-flow-diagram.controls.to-date-label",
        "defaultMessage": "To date"
    }
});
var $d22ff3171a5b4f16$export$2e2bcd8739ae039 = $d22ff3171a5b4f16$var$messages;

});

parcelRegister("fkqVe", function(module, exports) {

$parcel$export(module.exports, "getControlsStateFromZoom", () => $b7e39e99e99233e5$export$cb2b9225bf64c69a);
$parcel$export(module.exports, "parseDatePickerDate", () => $b7e39e99e99233e5$export$460204d7e507956);

var $3xcI8 = parcelRequire("3xcI8");

var $9IKEm = parcelRequire("9IKEm");

var $gkHn1 = parcelRequire("gkHn1");
const $b7e39e99e99233e5$export$cb2b9225bf64c69a = (zoomState, quickDateFilter)=>{
    if (zoomState.type === 'none') return {
        selectedOption: (0, $gkHn1.QUICK_DATE_FILTER_LABELS_BY_VALUE)[0, $9IKEm.QUICK_DATE_FILTER_ALL_TIME],
        fromDate: '',
        toDate: ''
    };
    if (zoomState.type === 'percentage') return {
        selectedOption: (0, $gkHn1.QUICK_DATE_FILTER_LABELS_BY_VALUE)[quickDateFilter],
        fromDate: '',
        toDate: ''
    };
    return {
        selectedOption: (0, $gkHn1.QUICK_DATE_FILTER_LABELS_BY_VALUE)[quickDateFilter],
        fromDate: zoomState.startValue != null ? new Date(zoomState.startValue) : '',
        toDate: zoomState.endValue != null ? new Date(zoomState.endValue) : ''
    };
};
const $b7e39e99e99233e5$export$460204d7e507956 = (value)=>new Date((0, $3xcI8.default)(value));

});



parcelRegister("esTb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfa302d31fefad55$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $bfa302d31fefad55$var$messages = (0, $90IgZ.defineMessages)({
    fetchError: {
        "id": "software-reports-cumulative-flow-diagram.fetch-error",
        "defaultMessage": "There was an error while fetching your report."
    },
    retryOnError: {
        "id": "software-reports-cumulative-flow-diagram.retry-on-error",
        "defaultMessage": "Retry"
    },
    emptyReportHeader: {
        "id": "software-reports-cumulative-flow-diagram.empty-report-header",
        "defaultMessage": "You don't have enough data for this report."
    },
    emptyReportDescription: {
        "id": "software-reports-cumulative-flow-diagram.empty-report-description",
        "defaultMessage": "Try creating issues and moving them through columns."
    }
});
var $bfa302d31fefad55$export$2e2bcd8739ae039 = $bfa302d31fefad55$var$messages;

});

parcelRegister("1QlUY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("h0h0Z").then(()=>parcelRequire('6H6w1'));

});



parcelRegister("lldcY", function(module, exports) {

$parcel$export(module.exports, "createReportPageBootstrap", () => $d67e138b0ee59756$export$62233a4527423be3);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $fee69 = parcelRequire("fee69");

var $d6f6c = parcelRequire("d6f6c");

var $fFiKW = parcelRequire("fFiKW");

var $fO5rB = parcelRequire("fO5rB");

var $5p2pw = parcelRequire("5p2pw");

var $bhwgQ = parcelRequire("bhwgQ");

var $7BhMl = parcelRequire("7BhMl");

var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $edolg = parcelRequire("edolg");
class $d67e138b0ee59756$export$883262dc952d8f59 extends (0, $eUqFw.Component) {
    getUrlParams() {
        const { match: match } = this.props;
        const { boardId: boardId, projectKey: projectKey } = match.params;
        return {
            boardId: Number(boardId),
            projectKey: projectKey
        };
    }
    renderContents() {
        const { App: App } = this.props;
        const { boardId: boardId, projectKey: projectKey } = this.getUrlParams();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $edolg.ProjectAppContainer), {
                projectKey: projectKey || ''
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
                subProduct: "software"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(App, {
                baseUrl: tenantContext.baseUrl,
                projectKey: projectKey || '',
                boardId: boardId
            })));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7BhMl.LicenseCheck), {
            type: "software"
        }, ({ result: result })=>result ? this.renderContents() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null)));
    }
}
const $d67e138b0ee59756$export$62233a4527423be3 = (page, App)=>// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; } & { App: ComponentType<AppProps>; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
    (0, $lB25E.withRouter)((props)=>{
        const projectInfo = (0, $fFiKW.useProjectAnalyticsAttributes)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "report-page-bootstrap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
            id: `spa-app-bootstrap.next-gen.reports.${page}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireTrackAnalytics), {
            actionSubject: "report",
            action: "viewed",
            actionSubjectId: page,
            attributes: {
                ...projectInfo
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d67e138b0ee59756$export$883262dc952d8f59, {
            ...props,
            App: App
        })));
    });

});
parcelRegister("fFiKW", function(module, exports) {

$parcel$export(module.exports, "useProjectSimplified", () => $23f818101ec73ec4$export$9f0c70b531288073);
$parcel$export(module.exports, "useProjectAnalyticsAttributes", () => $23f818101ec73ec4$export$b6a91b2d78273787);

var $bNe1g = parcelRequire("bNe1g");

var $6vrw7 = parcelRequire("6vrw7");

var $lB25E = parcelRequire("lB25E");
const $23f818101ec73ec4$export$f87be37f8e8be65 = ()=>{
    const [projectKey] = (0, $lB25E.usePathParam)('projectKey');
    if (projectKey == null) throw new Error('Project key missing');
    return (0, $6vrw7.toProjectKey)(projectKey);
};
const $23f818101ec73ec4$export$16d1475ed6c26568 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    return data === null ? null : (0, $6vrw7.toProjectId)(`${data.projectId}`);
};
const $23f818101ec73ec4$export$4d975d76445a6650 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    if (data === null) return null;
    const { isProjectAdmin: isProjectAdmin } = data;
    return isProjectAdmin === undefined ? null : isProjectAdmin;
};
const $23f818101ec73ec4$export$9f0c70b531288073 = ()=>{
    const { data: data } = (0, $bNe1g.useProjectContext)();
    return data === null ? null : data.simplified;
};
const $23f818101ec73ec4$export$b6a91b2d78273787 = ()=>{
    const projectId = $23f818101ec73ec4$export$16d1475ed6c26568();
    const isProjectAdmin = $23f818101ec73ec4$export$4d975d76445a6650();
    const isProjectSimplified = $23f818101ec73ec4$export$9f0c70b531288073();
    if (projectId === null || isProjectAdmin === null || isProjectSimplified === null) return null;
    return {
        isSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        projectId: projectId
    };
};

});

parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("5p2pw", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $de0deb0ce0efa641$export$52d8964299339cae);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $de0deb0ce0efa641$var$LazyNoSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4qojl")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $de0deb0ce0efa641$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de0deb0ce0efa641$var$LazyNoSoftwareLicense, null));

});
parcelRegister("4qojl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd5QC").then(()=>parcelRequire('4kT9n'));

});


parcelRegister("7BhMl", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $623739831bab1cba$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $623739831bab1cba$export$944be0b3bf2a6feb);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");
const $623739831bab1cba$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $623739831bab1cba$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$623739831bab1cba$var$appPermissionMapper[type]]);
const $623739831bab1cba$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $623739831bab1cba$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("edolg", function(module, exports) {

$parcel$export(module.exports, "ProjectAppContainer", () => $1822e422b99b1735$export$2925ae38aba4f7e6);

var $eUqFw = parcelRequire("eUqFw");

var $dpXKE = parcelRequire("dpXKE");

var $bNe1g = parcelRequire("bNe1g");
const $1822e422b99b1735$export$2925ae38aba4f7e6 = ({ children: children, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            projectKey: projectKey,
            projectName: projectData ? projectData.projectName : ''
        }, children));

});




//# sourceMappingURL=async-next-gen-reports-cumulative.5a4fa1ac.js.map
